export const servermaintenanacement = {
    maintenancement: false,
    ETC: new Date('2026-04-03T19:50:00'),
    message: "기능을 추가하기 위해 잠시 점검을 시작합니다."
}